import { render, staticRenderFns } from "./spuEdit.vue?vue&type=template&id=00883839&scoped=true"
import script from "./spuEdit.vue?vue&type=script&lang=js"
export * from "./spuEdit.vue?vue&type=script&lang=js"
import style0 from "./spuEdit.vue?vue&type=style&index=0&id=00883839&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00883839",
  null
  
)

export default component.exports